<template>
  <div class="pb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7">
          <div class="section-title left-title">
            <span class="top-title">Client Testimonials</span>
            <h2 title="We connect brands with celebrities and influencers for powerful digital campaigns.">We help to achieve customers business goals</h2>
          </div>

          <swiper
            :spaceBetween="25"
            :slidesPerView="1"
            :preventClicks="true"
            :loop="true"
            :autoplay="{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }"
            :navigation="{
              nextEl: '.next',
              prevEl: '.prev',
            }"
            :modules="modules"
            class="testimonial-slide"
          >
            <swiper-slide
              v-for="testimonial in testimonials"
              :key="testimonial.id"
            >
              <div class="testimonials-single-item">
                <span class="quality">{{ testimonial.quality }}</span>
                <p>{{ testimonial.description }}</p>
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <img :src="testimonial.image" alt="testimonials" />
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <h3 title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore">{{ testimonial.name }}</h3>
                    <span class="degeneration">{{ testimonial.designation }}</span>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-controller position-absolute bottom-0 end-0 z-1">
              <div class="controller-icon prev">
                <i class="ri-arrow-left-line"></i>
              </div>
              <div class="controller-icon next">
                <i class="ri-arrow-right-line"></i>
              </div>
            </div>
          </swiper>
        </div>

        <div
          class="col-lg-5 mt-4 mt-lg-0"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="testimonials-review">
            <div class="award-single-item review-on">
              <div class="d-flex align-items-center mb-1">
                <p class="review">Review On</p>
                <div>
                  <img title="We connect brands with celebrities and influencers for powerful digital campaigns."
                    class="trustpilot"
                    src="../../assets/images/trustpilot-stars.png"
                    alt="trustpilot-stars"
                  />
                </div>
              </div>
              <div class="d-flex align-items-center">
                <img title="We connect brands with celebrities and influencers for powerful digital campaigns."
                  class="review"
                  src="../../assets/images/google.png"
                  alt="trust"
                  style="height:30px;"
                />
                <p>100+ Reviews</p>
              </div>
            </div>
            <div class="award-single-item review-on">
              <div class="d-flex align-items-center mb-1">
                <p class="review">Review On</p>
                <div>
                  <img title="We connect brands with celebrities and influencers for powerful digital campaigns." src="../../assets/images/icon-star.png" alt="icon-star" v-for="i in 5" :key="i" />
                </div>
              </div>
              <div class="d-flex align-items-center">
                <img title="We connect brands with celebrities and influencers for powerful digital campaigns."
                  class="review"
                  src="../../assets/images/company.png"
                  alt="company"
                />
                <p>100+ Reviews</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";

export default defineComponent({
  name: "TestimonialsContent",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      testimonials: [
        {
          id: 1,
          quality: "Brand Visibility",
          description:
            "Working with MyCelebrity was seamless and effective. Their celebrity-led campaigns gave us massive regional reach and made our festive promotions a huge success.",
          image: require("../../assets/logos/clients/c2.jpg"),
          name: "Ramraj Cotton",
          designation: "Marketing Head, Ramraj Cotton",
          alt:"Ramraj"
        },
        {
          id: 2,
          quality: "Campaign Strategy",
          description:
            "They brought in the perfect mix of glamour and strategy. Our product launch was not just successful — it was unforgettable.",
          image: require("../../assets/logos/clients/c1.jpg"),
          name: "Jos Alukkas",
          designation: "Brand Manager, Jos Alukkas",
          alt:"Jos Alukkas"
        },
        {
          id: 3,
          quality: "Event Management",
          description:
            "Their ability to manage events, PR, and influencer presence at scale helped us create strong brand recall within the construction and machinery industry.",
          image: require("../../assets/logos/clients/c8.jpg"),
          name: "Casagrande India",
          designation: "Director, Casagrande India",
          alt:"Casagrande"
        },
        {
          id: 4,
          quality: "Influencer Marketing",
          description:
            "From influencer selection to full campaign execution, MyCelebrity understood our target market and delivered authentic content that connected with households across South India.",
          image: require("../../assets/logos/clients/c16.jpg"),
          name: "Sunpure Oil",
          designation: "Marketing Team, Sunpure",
          alt:"Sunpure oil"
        },
        {
          id: 5,
          quality: "Content Strategy",
          description:
            "We wanted a content-first approach with real engagement — and they nailed it. Their influencer strategy helped us reach younger male audiences more organically.",
          image: require("../../assets/logos/clients/c4.jpg"),
          name: "Man Matters",
          designation: "Digital Head, Man Matters",
          alt: "Man Matters"
        },
        {
          id: 6,
          quality: "Audience Trust",
          description:
            "We needed relatable mom influencers and quality content at scale. MyCelebrity delivered both with precision and care, helping us increase trust among young parents.",
          image: require("../../assets/logos/clients/littlejoys.jpg"),
          name: "Little Joys",
          designation: "Growth Manager, Little Joys",
          alt: "Little joys"
        },
      ],
    };
  },
  setup() {
    return {
      Autoplay,
      modules: [Navigation],
    };
  },
});
</script>

<style lang="scss" scoped>
.testimonials-single-item {
  .quality {
    background-color: #ffeeee;
    padding: 15px 23px;
    font-weight: 500;
    font-size: 18px;
    color: var(--headingColor);
    border-radius: 50px;
    font-family: var(--headingFontFamily);
    margin-bottom: 20px;
    display: inline-block;
  }
  p {
    font-weight: 500;
    font-size: 18px;
    color: #4c4c4c;
    font-style: italic;
    line-height: 26px;
    margin-bottom: 40px;
    max-width: 648px;
  }
  img {
    //border-radius: 100px;
    border: 1px solid var(--headingColor);
    width: 180px;
    height: 60px;
    object-fit: cover;
  }
  h3 {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 5px;
  }
}
.testimonials-review {
  border-radius: 20px;
  background-color: #faf4f4;
  padding: 115px 100px;
  .award-single-item {
    border-bottom: 1px solid #e3e3e3;
    padding-bottom: 50px;
    margin-bottom: 50px;
    &:last-child {
      padding-bottom: 0;
      margin-bottom: 0;
      border: none;
    }
    &.review-on {
      .review {
        margin-right: 55px;
      }
      .trustpilot {
        margin-left: 50px;
      }
    }
  }
}
.award-single-item {
  margin-bottom: 25px;
  &.review-on {
    p {
      font-weight: 500;
      color: var(--headingColor);
      margin-bottom: 0 !important;
      &.review {
        position: relative;
        top: 2px;
      }
    }
    img {
      margin-right: 5px;
    }
    .review {
      margin-right: 27px;
    }
  }
}

/* Responsive adjustments */
@media only screen and (max-width: 991px) {
  .testimonials-review {
    padding: 20px;
    .award-single-item.review-on {
      margin-bottom: 20px;
      padding-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
      }
      .trustpilot {
        margin-left: 0;
      }
    }
  }
  .testimonials-single-item {
    .quality {
      padding: 10px 15px;
      font-size: 16px;
    }
  }
}
</style>
